import { DynamicFormV2Palette } from "@mui/material";

export type FormFieldComponentTokenType = {
  labelTextColor: string;
  helperTextColor: string;
  errorHelperTextColor: string;
  countTextColor: string;
};

export const assignFieldComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    labelTextColor: formsPalette.text.intense,
    helperTextColor: isLightMode ? formsPalette.text.brand : formsPalette.text.intense,
    errorHelperTextColor: formsPalette.text.error,
    countTextColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.brand,
  } as FormFieldComponentTokenType;
};
